import { Select, Spinner } from "@chakra-ui/react";
import React, { Dispatch, SetStateAction } from "react";

const DrawDateSelection = ({
  drawDate,
  setDrawDate,
  allDrawDates,
  allDrawDays,
  isLoading,
}: {
  drawDate: string;
  setDrawDate: Dispatch<SetStateAction<string>>;
  allDrawDates: string[];
  allDrawDays: string[];
  isLoading: boolean;
}) => {
  if (isLoading) {
    return <Spinner size="md" />;
  }

  return (
    <Select
      onChange={(event) => setDrawDate(event.currentTarget.value)}
      value={drawDate || allDrawDates[0]}
    >
      {allDrawDates.map((date, index) => {
        return (
          <option key={date} value={date}>
            {allDrawDays[index]}, {date}
          </option>
        );
      })}
    </Select>
  );
};

export default DrawDateSelection;
